var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEightbit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 211,
    viewBox: "0 0 1765 211",
    width: 1765,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6640-9",
    transform: "matrix(3.4819148,0,0,3.4819148,20.836971,-15.698515)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 7.4975654,32.067509 v -0.64914 h 0.6491399 0.6491399 v 0.64914 0.64914 H 8.1467053 7.4975654 Z",
    id: "path6557",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 15.470815,34.147869 c -0.01452,-0.83915 -0.04585,-1.254778 -0.09856,-1.307398 -0.05178,-0.05168 -0.484306,-0.08781 -1.310664,-0.109482 l -1.233388,-0.03234 -0.02007,-1.221276 c -0.01466,-0.891944 -0.04279,-1.243992 -0.104304,-1.30551 -0.06157,-0.06157 -0.415278,-0.08966 -1.314508,-0.104394 l -1.230276,-0.02016 v -5.319013 -5.319012 h 0.64745 0.647451 l 0.01792,4.573219 c 0.01344,3.429569 0.03724,4.592537 0.0952,4.650468 0.05182,0.0518 0.481936,0.08786 1.305641,0.109456 l 1.228363,0.03221 0.03221,1.228364 c 0.02161,0.824409 0.05763,1.253776 0.109524,1.30564 0.09083,0.09078 3.724305,0.112994 3.814151,0.02332 0.02973,-0.02968 0.0636,-0.621207 0.07525,-1.314508 l 0.02119,-1.260547 H 33.459023 48.76466 l 0.03244,1.237231 c 0.02179,0.831003 0.05783,1.262603 0.109757,1.314508 0.09083,0.09078 3.724305,0.112994 3.814151,0.02332 0.02974,-0.02968 0.06355,-0.617428 0.07515,-1.306112 l 0.02109,-1.252151 1.237406,-0.02964 c 1.112353,-0.02664 1.246348,-0.04187 1.325879,-0.150631 0.07269,-0.09941 0.08847,-0.929534 0.08847,-4.652565 v -4.531572 h 0.681597 0.681597 v 5.317983 5.317984 l -1.26271,0.02119 c -0.864417,0.01451 -1.287044,0.04557 -1.339855,0.09847 -0.05166,0.05175 -0.08778,0.48301 -0.109351,1.305641 l -0.03221,1.228363 -1.228364,0.03221 c -0.750534,0.01968 -1.255657,0.0595 -1.29853,0.102374 -0.04291,0.04291 -0.08277,0.550803 -0.102606,1.307398 l -0.03244,1.237231 H 50.791152 50.15617 l -0.02129,-1.230254 c -0.01452,-0.83915 -0.04585,-1.254778 -0.09856,-1.307398 -0.05175,-0.05166 -0.483011,-0.08778 -1.30564,-0.109351 l -1.228364,-0.03221 -0.03221,-1.228363 c -0.02162,-0.82441 -0.05763,-1.253776 -0.109525,-1.305641 -0.09087,-0.09082 -3.724368,-0.112973 -3.814151,-0.02325 -0.02973,0.02971 -0.06262,1.220074 -0.07309,2.645245 l -0.01902,2.591219 h -2.658677 -2.658678 v -0.64914 -0.64914 l 1.801363,-0.0065 c 0.99075,-0.0036 1.874392,-0.02678 1.963648,-0.05161 l 0.162285,-0.04514 v -1.909109 -1.909109 l -0.162285,-0.04514 c -0.08926,-0.02483 -3.886725,-0.04514 -8.438818,-0.04514 -4.552093,0 -8.349561,0.02031 -8.438818,0.04514 l -0.162285,0.04514 v 1.909109 1.909109 l 0.162285,0.04514 c 0.08926,0.02483 0.972898,0.04805 1.963648,0.05161 l 1.801363,0.0065 v 0.64914 0.64914 h -2.659339 -2.659338 l -0.01836,-2.59121 c -0.0101,-1.425165 -0.04265,-2.615526 -0.07234,-2.645245 -0.07402,-0.07409 -3.349613,-0.108151 -3.621886,-0.03766 l -0.218973,0.05669 -0.01757,1.269012 -0.01757,1.26901 -1.267878,0.03183 c -0.784901,0.01971 -1.294786,0.05874 -1.338513,0.102468 -0.0435,0.0435 -0.0831,0.545958 -0.103073,1.307864 l -0.03244,1.237231 h -0.634982 -0.634982 z",
    id: "path6559",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 18.143459,24.050632 v -0.681597 h 5.283545 c 4.758019,0 5.287464,-0.01021 5.322947,-0.10268 0.02167,-0.05647 0.0394,-0.655306 0.0394,-1.330737 v -1.228056 h 1.291335 c 1.117645,0 1.296634,-0.01381 1.330736,-0.10268 0.02167,-0.05647 0.0394,-0.655306 0.0394,-1.330737 v -1.228057 h 2.012334 2.012334 v 1.25284 c 0,0.887879 0.02269,1.275532 0.0779,1.330737 0.05521,0.05521 0.442858,0.0779 1.330737,0.0779 h 1.25284 l 8.83e-4,1.18468 c 5.19e-4,0.651574 0.0185,1.250406 0.04003,1.330737 l 0.03914,0.146056 h 5.282919 5.282919 v 0.681597 0.681597 H 33.463157 18.143456 v -0.681597 z",
    id: "path6561",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 28.789353,8.0817913 V 7.4001945 h 4.673807 4.673807 V 8.0817913 8.7633882 H 33.46316 28.789353 Z",
    id: "path6563",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 20.804933,10.743265 v -0.681597 h 3.34307 3.34307 v 0.681597 0.681597 h -3.34307 -3.34307 z",
    id: "path6565",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 15.481986,13.404738 v -0.681597 h 2.012333 2.012334 v 0.681597 0.681597 h -2.012334 -2.012333 z",
    id: "path6567",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 12.820512,16.715352 v -1.330737 h 0.64914 0.64914 v 1.330737 1.330736 h -0.64914 -0.64914 z",
    id: "path6571",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 39.435247,10.743265 v -0.681597 h 3.34307 3.34307 v 0.681597 0.681597 h -3.34307 -3.34307 z",
    id: "path6573",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 47.484581,13.404738 v -0.681597 h 1.979877 1.979876 v 0.681597 0.681597 h -1.979876 -1.979877 z",
    id: "path6575",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 52.807528,16.715352 v -1.330737 h 0.64914 0.64914 v 1.330737 1.330736 h -0.64914 -0.64914 z",
    id: "path6577",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 50.146055,26.744562 v -0.649139 h 0.649139 0.64914 v 0.649139 0.64914 h -0.64914 -0.649139 z",
    id: "path6579",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 60.791948,36.741316 v -2.661473 h 0.681597 0.681597 v 2.661473 2.661474 h -0.681597 -0.681597 z",
    id: "path6581",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 58.130475,32.067509 v -0.64914 h 0.681597 0.681597 v 0.64914 0.64914 h -0.681597 -0.681597 z",
    id: "path6583",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 15.481986,26.744562 v -0.649139 h 0.64914 0.64914 v 0.649139 0.64914 h -0.64914 -0.64914 z",
    id: "path6585",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 4.771178,36.741316 v -2.661473 h 0.6815969 0.6815968 v 2.661473 2.661474 H 5.4527749 4.771178 Z",
    id: "path6587",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 7.4975654,42.064263 V 40.70107 h 0.6491399 0.6491399 v 1.363193 1.363194 H 8.1467053 7.4975654 Z",
    id: "path6589",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 26.12788,50.159037 c 0,-0.887879 -0.02269,-1.275532 -0.0779,-1.330736 -0.05798,-0.05798 -0.738577,-0.0779 -2.661474,-0.0779 H 20.80493 v -1.205176 c 0,-0.706621 -0.0278,-1.257118 -0.0672,-1.330737 -0.0629,-0.117536 -0.14795,-0.125561 -1.330737,-0.125561 h -1.263539 v -0.681596 -0.681597 h 2.559466 c 2.240235,0 2.572189,-0.01272 2.661473,-0.102008 0.08811,-0.08811 0.102008,-0.362226 0.102008,-2.012334 V 40.70107 h 0.681597 0.681597 v 1.934436 c 0,1.41801 0.0208,1.955233 0.0779,2.012334 0.0552,0.05521 0.442857,0.0779 1.330736,0.0779 h 1.25284 v 1.25284 c 0,0.887879 0.02269,1.275532 0.0779,1.330736 0.05942,0.05942 1.451451,0.0779 5.869407,0.0779 3.18533,0 5.837716,-0.01773 5.894189,-0.0394 0.08887,-0.0341 0.102681,-0.213091 0.102681,-1.330737 v -1.291334 h 1.228056 c 0.675432,0 1.274263,-0.01773 1.330737,-0.0394 0.09052,-0.03473 0.10268,-0.273161 0.10268,-2.012334 V 40.70107 h 0.67804 0.67804 l 0.01979,1.949855 c 0.01672,1.647709 0.03487,1.959383 0.117156,2.01134 0.05695,0.03596 1.155109,0.0619 2.645245,0.06248 l 2.547874,9.94e-4 v 0.681597 0.681596 h -1.261992 c -0.938309,0 -1.275461,0.02081 -1.314508,0.08114 -0.02888,0.04463 -0.06205,0.64346 -0.07371,1.330737 l -0.02119,1.249594 h -2.589313 c -2.49354,0 -2.591797,0.0046 -2.65651,0.12556 -0.0394,0.07362 -0.0672,0.624117 -0.0672,1.330737 v 1.205176 H 33.46316 26.12788 Z",
    id: "path6591",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 12.809247,47.50081 c -0.01165,-0.687277 -0.04482,-1.286109 -0.07371,-1.330737 -0.03905,-0.06033 -0.3762,-0.08114 -1.314508,-0.08114 H 10.159037 V 45.407337 44.72574 h 1.979876 1.979877 v 2.012333 2.012334 h -0.644176 -0.644177 z",
    id: "path6593",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 15.481986,50.73028 v -0.681596 h 0.64914 0.64914 v 0.681596 0.681597 h -0.64914 -0.64914 z",
    id: "path6595",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 18.143459,53.391754 v -0.681597 h 1.330737 1.330737 v 0.681597 0.681597 h -1.330737 -1.330737 z",
    id: "path6597",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 22.103212,56.053227 V 55.37163 h 1.363194 1.363194 v 0.681597 0.681597 h -1.363194 -1.363194 z",
    id: "path6599",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 26.12788,58.714701 v -0.681597 h 7.33528 7.335281 v 0.681597 0.681597 H 33.46316 26.12788 Z",
    id: "path6601",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 42.09672,56.053227 V 55.37163 h 1.363194 1.363194 v 0.681597 0.681597 H 43.459914 42.09672 Z",
    id: "path6603",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 46.121387,53.391754 v -0.681597 h 1.330737 1.330737 v 0.681597 0.681597 h -1.330737 -1.330737 z",
    id: "path6605",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 50.146055,50.73028 v -0.681596 h 0.649139 0.64914 v 0.681596 0.681597 h -0.64914 -0.649139 z",
    id: "path6607",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 52.807528,46.73807 v -2.012333 h 2.012334 2.012333 v 0.681597 0.681596 h -1.294449 c -0.906609,0 -1.308292,0.0224 -1.340653,0.07476 -0.02541,0.04112 -0.0604,0.63995 -0.07774,1.330736 l -0.03153,1.255976 h -0.640145 -0.640145 z",
    id: "path6609",
    transform: "translate(-0.189315,1.157648)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c196e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.0346208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 58.130475,42.064263 V 40.70107 h 0.681597 0.681597 v 1.363193 1.363194 h -0.681597 -0.681597 z",
    id: "path6611",
    transform: "translate(-0.189315,1.157648)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 431.3539,34.010567 v 0 h 17.64233 V 51.652895 69.295222 87.110514 H 431.3539 v 17.642326 h 17.64233 v 17.8153 17.64232 17.64233 17.8153 H 431.3539 v 17.64232 h -17.81529 -17.64232 -17.8153 -17.64232 -17.64233 -17.81529 v -17.64232 h -17.64233 v -17.8153 -17.64233 -17.64232 -17.8153 h 17.64233 V 87.110514 H 307.33872 V 69.295222 51.652895 34.010567 h 17.64233 V 16.195276 h 17.81529 17.64233 17.64232 17.8153 17.64232 17.81529 z m -17.81529,35.284655 v 0 -17.642327 h -17.64232 -17.8153 -17.64232 -17.64233 v 17.642327 h 17.64233 17.64232 17.8153 z m 0,53.272918 v 0 -17.8153 h -17.64232 -17.8153 -17.64232 -17.64233 v 17.8153 17.64232 17.64233 h 17.64233 17.64232 17.8153 17.64232 V 140.21046 Z M 656.38006,34.010567 v 0 h 17.64233 v 17.642328 17.815291 17.642328 h -17.64233 v 17.642326 h 17.64233 v 17.8153 17.64232 17.64233 17.8153 h -17.64233 v 17.64232 h -17.64232 -17.8153 -17.64232 -17.8153 -17.64232 -17.64233 -17.81529 V 175.66809 157.85279 140.21046 122.56814 104.75284 87.110514 69.468186 51.652895 34.010567 16.195276 h 17.81529 17.64233 17.64232 17.8153 17.64232 17.8153 17.64232 z M 638.73774,140.21046 v 0 -17.64232 h -17.8153 -17.64232 -17.8153 -17.64232 v 17.64232 17.64233 h 17.64232 17.8153 17.64232 17.8153 z m -17.8153,-53.099946 v 0 h 17.8153 V 69.468186 51.652895 h -17.8153 -17.64232 -17.8153 -17.64232 v 17.815291 17.642328 h 17.64232 17.8153 z M 822.25253,16.195276 v 0 20.928643 14.528976 h -17.81529 -17.64232 v 17.815291 17.642328 17.642326 17.8153 17.64232 17.64233 h 17.64232 17.81529 v 35.45762 H 804.43724 786.79492 769.15259 751.3373 733.69497 715.87968 v -35.45762 h 17.81529 17.64233 V 140.21046 122.56814 104.75284 87.110514 69.468186 51.652895 H 733.69497 715.87968 V 16.195276 h 17.81529 17.64233 17.81529 17.64233 17.64232 z m 0,0 v 0 h 17.64233 V 34.010567 51.652895 H 822.25253 804.43724 786.79492 769.15259 751.3373 733.69497 716.05264 698.23735 V 34.010567 16.195276 h 17.81529 17.64233 17.64233 17.81529 17.64233 17.64232 z m 0,141.830484 v 0 h 17.64233 v 17.64233 17.64232 H 822.25253 804.43724 786.79492 769.15259 751.3373 733.69497 716.05264 698.23735 v -17.64232 -17.64233 h 17.81529 17.64233 17.64233 17.81529 17.64233 17.64232 z M 987.95204,16.36824 v 0 h 17.81526 V 34.183531 51.825859 69.468186 H 987.95204 V 51.825859 h -17.64232 -17.64233 v 17.642327 17.815292 17.642332 17.64233 17.81529 17.64233 17.64233 17.81529 H 934.8521 917.20977 V 175.66809 158.02576 140.38343 122.56814 104.92581 87.283478 69.468186 51.825859 H 899.39448 881.75215 V 69.468186 H 864.10982 V 51.825859 34.183531 16.36824 h 17.64233 17.64233 17.81529 17.64233 17.81529 17.64233 z m 225.19916,35.284655 v 0 h 17.6423 v 17.815291 17.642328 17.642326 17.8153 17.64232 17.64233 h -17.6423 v 17.8153 h -17.8153 v 17.64232 h -17.6424 -17.6423 -17.8153 -17.6423 -17.6423 -17.8153 V 175.66809 157.85279 140.21046 122.56814 104.75284 87.110514 69.468186 51.652895 34.010567 16.195276 h 17.8153 17.6423 17.6423 17.8153 17.6423 17.6424 v 17.815291 h 17.8153 z m -17.8153,17.815291 v 0 -17.815291 h -17.6424 -17.6423 -17.8153 -17.6423 v 17.815291 17.642328 17.642326 17.8153 17.64232 17.64233 h 17.6423 17.8153 17.6423 17.6424 v -17.64233 -17.64232 -17.8153 -17.642326 z m 183.6877,-53.27291 v 0 h 17.6424 v 17.815291 17.642328 h -17.6424 -17.8153 -17.6423 -17.8153 -17.6423 -17.6423 v 17.815291 17.642328 h 17.6423 17.6423 17.8153 17.6423 17.8153 v 17.642326 h -17.8153 v 17.8153 h -17.6423 -17.8153 -17.6423 -17.6423 v 17.64232 17.64233 h 17.6423 17.6423 17.8153 17.6423 17.8153 17.6424 v 17.8153 17.64232 h -17.6424 -17.8153 -17.6423 -17.8153 -17.6423 -17.6423 -17.8153 -17.6423 V 175.66809 157.85279 140.21046 122.56814 104.75284 87.110514 69.468186 51.652895 34.010567 16.195276 h 17.6423 17.8153 17.6423 17.6423 17.8153 17.6423 z m 165.6995,0.172964 v 0 h 17.6424 v 17.815291 17.642328 17.642327 17.815292 17.642332 17.64233 17.81529 17.64233 17.81529 17.64233 h -17.6424 -17.6423 V 175.84105 158.02576 140.38343 122.56814 104.92581 87.283478 69.468186 h -17.8153 v 17.815292 17.642332 17.64233 17.81529 17.64233 17.81529 h -17.6423 -17.6423 V 158.02576 140.38343 122.56814 104.92581 87.283478 69.468186 h -17.8153 v 17.815292 17.642332 17.64233 17.81529 17.64233 17.81529 17.64233 h -17.6423 -17.6424 V 175.84105 158.02576 140.38343 122.56814 104.92581 87.283478 69.468186 51.825859 34.183531 16.36824 h 17.6424 17.6423 v 17.815291 h 17.8153 v 17.642328 h 17.6423 17.6423 V 34.183531 h 17.8153 V 16.36824 Z m 165.8726,17.815291 v 0 h 17.6423 v 17.642328 17.642327 17.815292 17.642332 17.64233 17.81529 17.64233 17.81529 h -17.6423 v 17.64233 h -17.6423 -17.8154 -17.6423 -17.8152 -17.6424 -17.6423 v -17.64233 h -17.8154 V 158.02576 140.38343 122.56814 104.92581 87.283478 69.468186 51.825859 34.183531 h 17.8154 V 16.36824 h 17.6423 17.6424 17.8152 17.6423 17.8154 17.6423 z m -17.6423,35.284655 v 0 -17.642327 h -17.8154 -17.6423 -17.8152 -17.6424 v 17.642327 17.815292 17.642332 17.64233 17.81529 17.64233 h 17.6424 17.8152 17.6423 17.8154 V 140.38343 122.56814 104.92581 87.283478 Z",
    id: "text2",
    style: {
      fontSize: 192,
      fontFamily: "Pixeboy",
      InkscapeFontSpecification: "Pixeboy",
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.983972,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    "aria-label": "8 bit demo"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.533333,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect122",
    width: 113.07491,
    height: 35.358932,
    x: 714.91339,
    y: 16.206177
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.533333,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect123",
    width: 129.2811,
    height: 34.253963,
    x: 705.33704,
    y: 158.74687
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.533333,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect124",
    width: 53.390842,
    height: 5.0786409,
    x: 697.98761,
    y: 156.91699
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.533333,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect125",
    width: 91.936447,
    height: 6.2506318,
    x: 748.25311,
    y: 157.04721
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126",
    width: 4.168016,
    height: 4.3283248,
    x: 73.840126,
    y: 78.911636
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0",
    width: 4.168016,
    height: 4.3283248,
    x: 116.28691,
    y: 19.12002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-1",
    width: 4.168016,
    height: 4.3283248,
    x: 152.91103,
    y: 19.244827
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-3",
    width: 4.168016,
    height: 4.3283248,
    x: 88.463829,
    y: 28.016916
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-0",
    width: 4.168016,
    height: 4.3283248,
    x: 69.518471,
    y: 37.590549
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-8",
    width: 4.168016,
    height: 4.3283248,
    x: 60.377628,
    y: 51.220036
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-6",
    width: 4.168016,
    height: 4.3283248,
    x: 181.10614,
    y: 28.571686
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-4",
    width: 4.168016,
    height: 4.3283248,
    x: 199.4874,
    y: 37.683556
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-9",
    width: 4.168016,
    height: 4.3283248,
    x: 209.22459,
    y: 51.425209
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-49",
    width: 4.168016,
    height: 4.3283248,
    x: 51.214344,
    y: 92.935722
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-91",
    width: 4.168016,
    height: 4.3283248,
    x: 41.756153,
    y: 102.62477
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-93",
    width: 4.168016,
    height: 4.3283248,
    x: 218.09204,
    y: 93.144135
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-03",
    width: 4.168016,
    height: 4.3283248,
    x: 227.64413,
    y: 102.69208
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-19",
    width: 4.168016,
    height: 4.3283248,
    x: 41.667332,
    y: 125.69654
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-69",
    width: 4.168016,
    height: 4.3283248,
    x: 51.240047,
    y: 140.06024
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-16",
    width: 4.168016,
    height: 4.3283248,
    x: 69.534363,
    y: 158.17183
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-48",
    width: 4.168016,
    height: 4.3283248,
    x: 78.883659,
    y: 167.61411
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-14",
    width: 4.168016,
    height: 4.3283248,
    x: 92.811333,
    y: 176.77737
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-81",
    width: 4.168016,
    height: 4.3283248,
    x: 106.64597,
    y: 186.00797
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-31",
    width: 4.168016,
    height: 4.3283248,
    x: 162.4814,
    y: 186.05609
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-5",
    width: 4.168016,
    height: 4.3283248,
    x: 176.30669,
    y: 176.89284
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-84",
    width: 4.168016,
    height: 4.3283248,
    x: 190.39467,
    y: 167.68469
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-30",
    width: 4.168016,
    height: 4.3283248,
    x: 199.6734,
    y: 158.38351
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-2",
    width: 4.168016,
    height: 4.3283248,
    x: 218.29486,
    y: 139.60176
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87",
    width: 4.168016,
    height: 4.3283248,
    x: 227.23051,
    y: 125.85686
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0",
    width: 4.168016,
    height: 4.3283248,
    x: 102.37605,
    y: 111.79131
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-5",
    width: 4.168016,
    height: 4.3283248,
    x: 107.17505,
    y: 111.81046
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-1",
    width: 4.168016,
    height: 4.3283248,
    x: 111.93943,
    y: 111.7656
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-6",
    width: 4.168016,
    height: 4.3283248,
    x: 115.87983,
    y: 111.78804
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-3",
    width: 4.168016,
    height: 4.3283248,
    x: 153.40787,
    y: 111.72401
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-5-3",
    width: 4.168016,
    height: 4.3283248,
    x: 158.20688,
    y: 111.74316
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-1-5",
    width: 4.168016,
    height: 4.3283248,
    x: 162.97127,
    y: 111.69828
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c196e",
      fillRule: "evenodd",
      stroke: "#5c196e",
      strokeWidth: 0.92851,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect126-0-87-0-6-0",
    width: 4.168016,
    height: 4.3283248,
    x: 166.91167,
    y: 111.72073
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEightbit);
export default __webpack_public_path__ + "static/media/logo-eightbit.e8615e94696cc3dd075ef8ceea232e8b.svg";
export { ForwardRef as ReactComponent };